// inactivity.service.ts
import { Injectable } from "@angular/core";
import { fromEvent, timer, Observable } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class InactivityService {
  private inactivityTimer$: Observable<any>;

  constructor() {
    // Set the inactivity period to 2 minutes (2 * 60 * 1000 milliseconds)
    // const inactivityPeriod = 2 * 60 * 1000;
    const inactivityPeriod = 1000;
    this.inactivityTimer$ = fromEvent(document, "mousemove").pipe(
      // This listens for mousemove events
      switchMap(() => timer(inactivityPeriod)),
      takeUntil(fromEvent(document, "click")) // Reset timer on any click
    );
  }

  startInactivityTimer(): Observable<any> {
    console.log("mosuse overrrrr");
    return this.inactivityTimer$;
  }
}
